/***
 * @file: åæ¢è´¦æ·
 * @author: linkun.he
 * @Date: 2020-01-03 11:45:29
 */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SettingsService } from '@ithinkdt/shared/browser';
import { BaseAjaxService } from '@ithinkdt/shared/http';

import { API } from './api';

@Injectable({ providedIn: 'root' })
export class ChangeAccountService extends BaseAjaxService {
  private auth: any = this.settings.userConfig.env.serverName.auth;
  private change: any = this.settings.userConfig.env.serverName.change;
  constructor(private settings: SettingsService, http: HttpClient) {
    super(http);
  }

  // è·åç§æ·è´¦å·åè¡¨
  getAccountList(param?: any): Observable<any> {
    return this.post(this.auth + API.getAccountListUrl, param);
  }

  // è®¾ç½®é»è®¤ç¨æ·
  settingDefaultAccount(param?: any): Observable<any> {
    return this.post(this.auth + API.settingDefaultAccountUrl, param);
  }

  // åæ¢è´¦æ·
  exchangeAccount(param?: any): Observable<any> {
    return this.post(this.auth + API.exchangeAccountUrl, param);
  }
  // todoä¿¡æ¯
  querTaskAccount(param?: any): Observable<any> {
    return this.postJson(this.change + API.querTask, param);
  }
}
